export type ResponseZboziPlaOfferData = {
	image: string;
	impression: string;
	impression_control: string;
	premiseName: string;
	price: number;
	time: string;
	title: string;
	type: 'zbozi';
	url: string;
};

export type ZboziPlaOfferData = {
	id: string;
	image: string;
	impression: string;
	impressionControl: string;
	premiseName: string;
	price: number;
	time: string;
	title: string;
	type: 'zbozi';
	url: string;
	isZboziPlaOffer: true;
};

export function normalizePlaOfferData(data: ResponseZboziPlaOfferData): ZboziPlaOfferData {
	return {
		id: data.url,
		image: data.image,
		impression: data.impression,
		impressionControl: data.impression_control,
		premiseName: data.premiseName,
		price: data.price,
		time: data.time,
		title: data.title,
		type: data.type,
		url: data.url,
		isZboziPlaOffer: true,
	};
}

export type ResponseZboziPromoOfferData = {
	image: string;
	link: string;
	parameters: string[];
	price_from: number;
	price_to: number;
	shop_count: number;
	title: string;
};

export type ZboziPromoOfferData = {
	id: string;
	link: string;
	image: string;
	priceFrom: number;
	priceTo: number;
	shopCount: number;
	title: string;
	isZboziPromoOffer: true;
};

export function normalizePromoOfferData(data: ResponseZboziPromoOfferData): ZboziPromoOfferData {
	return {
		id: data.link,
		image: data.image,
		link: data.link,
		priceFrom: data.price_from,
		priceTo: data.price_to,
		shopCount: data.shop_count,
		title: data.title,
		isZboziPromoOffer: true,
	};
}
